import React from 'react';

import Box from '@react/react-spectrum/Icon/Box';
import CallCenter from '@react/react-spectrum/Icon/CallCenter';
import { Card, CardCoverPhoto, CardBody } from '@react/react-spectrum/Card';
import DeviceDesktop from '@react/react-spectrum/Icon/DeviceDesktop';
import DevicePhone from '@react/react-spectrum/Icon/DevicePhone';
import GlobeOutline from '@react/react-spectrum/Icon/GlobeOutline';
import Wait from '@react/react-spectrum/Wait';

import { useProjectsBySandbox } from 'data/hooks';
import { getBuilderURL } from 'services/environment';

import './ProjectList.scss';

export default function ProjectList({ orgID, sandboxName }) {
  const projects = useProjectsBySandbox(orgID, sandboxName);

  if (projects.loading) {
    return <Wait size="S" />;
  }

  if (projects.error) {
    return <div>Couldn't load projects: {projects.error.message}</div>;
  }

  if (projects.data.projectsBySandbox.length === 0) {
    return <p>No projects found</p>;
  }

  const openProject = (project) => () => {
    window.open(`${getBuilderURL()}/projects/${project.id}`);
  };

  return (
    <div className="project-list small">
      {projects.data.projectsBySandbox.map((project) => (
        <Card
          allowsSelection={false}
          onClick={openProject(project)}
          key={`project-${project.id}`}>
          <CardCoverPhoto src={project.meta?.thumbnail} />
          <CardBody title={project.meta?.title} subtitle={project.id}>
            <ProjectTypeIcon type={project.meta?.type} />
          </CardBody>
        </Card>
      ))}
    </div>
  );
}

const ProjectTypeIcon = ({ type }) => {
  let icon;
  switch (type) {
    case 'mobile':
      icon = <DevicePhone size="S" />;
      break;
    case 'web':
      icon = <DeviceDesktop size="S" />;
      break;
    case 'call-center':
      icon = <CallCenter size="S" />;
      break;
    case 'external-website':
      icon = <GlobeOutline size="S" />;
      break;
    default:
      icon = <Box size="S" />;
      break;
  }

  return <div className="project-type-icon">{icon}</div>;
};
